import React from "react";
import { connect } from "react-redux";
import Login from "./authentication/Login";
import News from "./News";
import Grid from "@material-ui/core/Grid";
import Statistic from "./Statistic";
import Storybook from "./Storybook";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next"; // Import withTranslation

const styles = (theme) => ({
    root: {
        padding: theme.spacing.unit * 2,
    },
});

const Home = (props) => {
    const { t, i18n, classes } = props; // Destructure t from props
    const lang = i18n.language || "bg"; // <- Always read live language
    return (
        <Grid container spacing={16}>
            <Grid item xs={12} sm={4}>
                <News />
            </Grid>
            <Grid item xs={12} sm={5}>
                <Storybook />
            </Grid>
            <Grid item xs={12} sm={3}>
                <Grid container spacing={16}>
                    <Grid item xs={12}>
                        <Login />
                    </Grid>
                    <Grid item xs={12}>
                    <Paper className={classes.root}>
                        {/*<picture>*/}
                        {/*    <a href="https://www.unwe.bg">*/}
                        {/*        <img*/}
                        {/*            srcSet={*/}
                        {/*                lang === "bg"*/}
                        {/*                    ? "/img/105.bg.jpg"*/}
                        {/*                    : "/img/105.EN.jpg"*/}
                        {/*            }*/}
                        {/*            alt={t("unwe105YearsAlt")}*/}
                        {/*        />*/}
                        {/*    </a>*/}
                        {/*</picture>*/}
                            <picture>
                                <a href="https://alumni.unwe.bg/">
                                    <img
                                        srcSet={
                                            lang === "bg"
                                                ? "/img/Logo_cut.jpg"
                                                : "/img/Logo_cut_en.jpg"
                                        }
                                />
                            </a>
                        </picture>
                    </Paper>
                    </Grid>
                   
                    <Grid item xs={12}>
                        <Statistic />
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default withTranslation()(
    connect()(
        withStyles(styles)(Home)
    )
);

//export default withTranslation()(connect()(Home)); // Wrap the component with withTranslation

//import React from 'react';
//import { connect } from 'react-redux';
//import Login from './authentication/Login';
//import News from './News';
//import Grid from '@material-ui/core/Grid';
//import Statistic from './Statistic';
//import Storybook from './Storybook';

//const Home = props => (
//    <Grid container spacing={16}>
//        <Grid item xs={12} sm={4}>
//            <News />
//        </Grid>
//        <Grid item xs={12} sm={5}>
//            <Storybook />
//        </Grid>
//        <Grid item xs={12} sm={3}>
//            <Grid container spacing={16}>
//                <Grid item xs={12}>
//                    <Login />
//                </Grid>
//                <Grid item xs={12}>
//                    <a href="https://www.unwe.bg"><img src="https://www.unwe.bg/Content/100years/100yearsunwe.PNG" alt="100 ������ ����" width="100%" /></a>
//                    <a href="https://www.idealcandidate.bg"><img src="/img/ideal.jpg" alt="��������� ��������" width="100%" /></a>
//                </Grid>
//                <Grid item xs={12}>
//                    <Statistic />
//                </Grid>
//            </Grid>
//        </Grid>
//    </Grid>
//);

//export default connect()(Home);
